// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ToggleContract = contract({
  name: "Toggle",
  description: "A standalone on/off button — Bold/Italic in a toolbar, \"Show grid\" in a header, single binary toggle that doesn't belong inside a Switch row. For two-or-more mutually-exclusive options use ToggleGroup. For a labeled settings switch (\"Active: on/off\") use Switch.",
  import: "@gradeui/ui",
  aliases: ["toggle","toggle button","press button","bold button","italic button"],
  composesWith: ["Tooltip (wrap an icon-only Toggle)","Row","TabsList (sibling)"],
  styleDefaults: {"Toggle":"inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-transparent h-9 px-2 min-w-9"},
  variantDefaults: {"variant":"default","size":"default"},
  props: {
  "variant": {
      schema: z.enum(["default", "outline"]).optional(),
      design: "knob",
      description: "outline adds a border, default is borderless and ghost-like",
  },
  "size": {
      schema: z.enum(["default", "sm", "lg"]).optional(),
      design: "knob",
  },
  "pressed": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "controlled pressed state",
  },
  "defaultPressed": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "uncontrolled initial state",
  },
  "onPressedChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "disabled": {
      schema: z.boolean().optional(),
      design: "knob",
  },
  "children": {
      schema: z.unknown(),
      design: "plumbing",
      description: "usually an icon or short label",
  },
  },
});
